import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  createMatchReport (matchReport) {
    console.log(matchReport)
    let body = JSON.stringify(matchReport)
    console.log(body)
    return Vue.http.post(urls.MATCH_REPORT_ROOT, body, {'headers': authHeaders.getAuthHeaders()})
  },
  getAllMatchReport () {
    return Vue.http.get(urls.MATCH_REPORT_ROOT)
  },
  getLatestlMatchReport () {
    return Vue.http.get(urls.MATCH_REPORT_ROOT + '?size=20')
  },
  getAllMatchReportForLeague (leagueName) {
    var target = urls.MATCH_REPORT_ROOT + '?league=' + leagueName
    return Vue.http.get(target)
  },
  getPublishedMatchReport (size = undefined) {
    let target = urls.MATCH_REPORT_ROOT + '?published'
    if (size) {
      target = target + '&size=10'
    }
    return Vue.http.get(target)
  },
  getMatchReport (id) {
    let target = urls.MATCH_REPORT_ROOT + id + '/'
    return Vue.http.get(target)
  },
  getMatchReportForTeam (teamId) {
    let target = urls.MATCH_REPORT_ROOT + '?team=' + teamId
    return Vue.http.get(target)
  },
  getAllMatchReportForCoach (coachId) {
    let target = urls.MATCH_REPORT_ROOT + '?user=' + coachId
    return Vue.http.get(target)
  },
  updateMatchReport (matchReport) {
    let target = urls.MATCH_REPORT_ROOT + matchReport.id + '/'
    let body = JSON.stringify(matchReport)
    return Vue.http.patch(target, body, {'headers': authHeaders.getAuthHeaders()})
  },
  publishMatchReport (matchReportId) {
    let target = urls.MATCH_REPORT_ROOT + matchReportId + '/publish/'
    return Vue.http.patch(target, '', {'headers': authHeaders.getAuthHeaders()})
  },
  cancelMatch (matchReportId) {
    let target = urls.MATCH_REPORT_ROOT + matchReportId + '/unpublish/'
    return Vue.http.patch(target, '', {'headers': authHeaders.getAuthHeaders()})
  },
  deleteMatch (matchReportId) {
    let target = urls.MATCH_REPORT_ROOT + matchReportId + '/'
    return Vue.http.delete(target, {'headers': authHeaders.getAuthHeaders()})
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/match-report.api.js